/** @jsx jsx */
import PropTypes from "prop-types"
import { jsx, Box, Styled } from "theme-ui"
import Img from "gatsby-image"

const Card = ({ title, children, fluid, className, headingAs, Component }) => (
  <Box className={className} sx={{ mb: 4 }}>
    {fluid && (
      <Img
        fluid={fluid}
        alt=""
        sx={{ width: "100%", height: "auto", borderRadius: 10 }}
      />
    )}
    {Component && (
      <Component sx={{ width: "100%", height: "auto", borderRadius: 10 }} />
    )}
    <Styled.h3 as={headingAs} sx={{ mb: 3 }}>
      {title}
    </Styled.h3>
    <hr sx={{ height: "0.18rem", border: "none", bg: "primary", mb: 3 }} />
    {children}
  </Box>
)

Card.defaultProps = {
  external: false,
  fluid: false,
  Component: false,
  headingAs: "h3",
}

Card.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.any,
  fluid: PropTypes.any,
  className: PropTypes.string,
  headingAs: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  Component: PropTypes.any,
}

export default Card
